import React from "react";
import { useDispatch } from "react-redux";
import { openSnackBar } from "../../redux/actions/snackbar.actions";

const OtpInputField = ({
  t,
  length = 6,
  hasErrorMsg = null,
  otp,
  mfadataHandler,
}) => {
  const dispatch = useDispatch();
  const inputsRef = React.useRef([]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (!/^\d?$/.test(value)) return; // Only allow single digit numbers

    const newOtp = [...otp];
    newOtp[index] = value;
    mfadataHandler({ otp: newOtp, otpHasErrorMsg: "" });

    // Move to next input
    if (value && index < length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const focusInput = (index) => {
    if (index >= 0 && index < length) {
      inputsRef.current[index]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    const key = e.key;

    if (key === "Backspace" && !otp[index]) {
      focusInput(index - 1);
    } else if (key === "ArrowLeft") {
      e.preventDefault();
      focusInput(index - 1);
    } else if (key === "ArrowRight") {
      e.preventDefault();
      focusInput(index + 1);
    } else if (key.length === 1 && /^\d$/.test(key)) {
      // Replace if already filled
      inputsRef.current[index].value = "";
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").replace(/\D/g, "");
    if (!pastedData) {
      dispatch(
        openSnackBar({
          msg: t("invalid_opt_format"),
          type: "error",
        })
      );
    } else if (pastedData.length <= length) {
      const newOtp = pastedData.split("").slice(0, length);
      mfadataHandler({ otp: newOtp });
      newOtp.forEach((digit, i) => {
        inputsRef.current[i].value = digit;
      });
      focusInput(
        pastedData.length === 6 ? pastedData.length - 1 : pastedData.length
      );
    }
  };

  return (
    <>
      <div className="d-flex">
        {Array.from({ length }).map((_, index) => (
          <input
            key={index}
            type="text"
            inputMode="numeric"
            maxLength={length}
            onPaste={handlePaste}
            ref={(el) => (inputsRef.current[index] = el)}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            className={`me-3 py-2 px-10 border fw-medium cm-btn-radius-xl cm-otp-input-field ${
              hasErrorMsg
                ? "text-danger border-danger"
                : !!otp?.[index]
                ? "border-action-1"
                : "border-blue-gray-300"
            }`}
            value={otp[index]}
            style={{
              width: "40px",
              textAlign: "center",
            }}
          />
        ))}
      </div>
      {!!hasErrorMsg && (
        <span className="text-danger cm-xs-txt fw-medium pt-12 d-inline-block">
          {t(hasErrorMsg)}
        </span>
      )}
    </>
  );
};

export default OtpInputField;
